import { AppSchema } from '/common/types'
import { getAssetUrl } from '/web/shared/util'
import { JSX } from 'solid-js'
import '/node_modules/flag-icons/css/flag-icons.min.css'
import { A, useNavigate } from '@solidjs/router'
import { getOrCreateChatWithCharacter } from '/web/shared/aifans/lib/chat-util'

export default function PopularCreators(props: {
  creators: AppSchema.Character[]
  title: JSX.Element
}) {
  const nav = useNavigate()

  const link = (creator: AppSchema.Character) =>
    creator.slug
      ? `/model/${creator.categorySlug}/${creator.slug}`
      : `/model/${creator.categorySlug}/${creator._id}`
  return (
    <section class="popular-creators pt-16">
      <div class="container">
        <div class="wrapper">
          <div class="top flex flex-col items-center gap-4 py-4 sm:flex-row sm:justify-between">
            <div class="left">{props.title}</div>
          </div>

          <div class="content mt-4 grid gap-5 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
            {props.creators.map((creator) => (
              <div class="creator group relative cursor-pointer overflow-hidden rounded-xl ring-2 ring-transparent transition-all duration-300 hover:ring-primary">
                <div class="img relative h-[514px]">
                  <A href={link(creator)}>
                    {creator.avatar && (
                      <img
                        class="absolute h-full w-full object-cover"
                        src={getAssetUrl(creator.avatar)}
                        alt={creator.name}
                      />
                    )}
                  </A>

                  {/* icons */}
                  <div class="icons absolute right-3 top-3 grid gap-2">
                    <div class="relative flex h-[35px] w-[35px] items-center justify-center rounded-full before:absolute before:inset-0 before:rounded-full before:bg-gradient-to-br before:from-secondary before:to-primary before:transition-all before:duration-300 hover:before:rotate-90 hover:before:opacity-50">
                      <button
                        onClick={() => getOrCreateChatWithCharacter(creator._id, (url) => nav(url))}
                      >
                        <img
                          height={20}
                          width={20}
                          class="relative"
                          src="/images/icons/conversation.png"
                          alt="conversation"
                        />
                      </button>
                    </div>
                    <div class="flex h-[35px] w-[35px] items-center justify-center rounded-full bg-primary duration-300 hover:bg-opacity-50">
                      <A href={`/generate-image/${creator._id}`}>
                        <img
                          height={20}
                          width={20}
                          src="/images/icons/generate.svg"
                          alt="generate"
                        />
                      </A>
                    </div>
                  </div>
                </div>
                {/* info */}
                <A href={`/model/${creator._id}`}>
                  <div class="information absolute -bottom-[0.1rem] left-0 right-0 flex justify-between gap-2 p-2.5 font-medium before:absolute before:inset-0 before:bg-black before:bg-opacity-60 before:backdrop-blur-md before:duration-300 after:absolute after:inset-0 after:z-0 after:bg-gradient-to-tr after:from-primary after:to-secondary after:opacity-0 after:transition-all group-hover:after:opacity-100">
                    <div class="left relative z-10 space-y-1">
                      <div class="costume text-lg leading-none">{creator.name}</div>
                      <div class="country flex items-center gap-2">
                        <span class="text-xs font-bold leading-none text-cyan">
                          {creator.age} <span class="pl-[2px]">{creator.country || 'US'}</span>
                        </span>
                        <span
                          class={`fi fi-${
                            creator.country?.toLowerCase() || 'us'
                          } h-[10px] w-[15px]`}
                        ></span>
                      </div>
                    </div>

                    <div class="right relative z-10">
                      <div class="name flex h-[30px]  min-w-[101px] items-center justify-center rounded-full bg-white/[12%] px-3 text-cyan">
                        <h3>{creator.realName}</h3>
                      </div>
                    </div>
                  </div>
                </A>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
